var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-modal",
    {
      attrs: {
        title: _vm.title,
        width: 800,
        ok: false,
        visible: _vm.visible,
        confirmLoading: _vm.confirmLoading,
        okButtonProps: { props: { disabled: _vm.disableSubmit } },
        cancelText: "关闭"
      },
      on: { ok: _vm.handleOk, cancel: _vm.handleCancel }
    },
    [
      _c(
        "a-spin",
        { attrs: { spinning: _vm.confirmLoading } },
        [
          _c(
            "a-form",
            { attrs: { form: _vm.form } },
            [
              _c(
                "a-form-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    label: "用户账号"
                  }
                },
                [
                  _c("a-input", {
                    attrs: { readOnly: "", placeholder: "请输入用户账号" },
                    model: {
                      value: _vm.model.username,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "username", $$v)
                      },
                      expression: "model.username"
                    }
                  })
                ],
                1
              ),
              _c(
                "a-form-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    label: "用户姓名"
                  }
                },
                [
                  _c("a-input", {
                    attrs: { readOnly: "", placeholder: "用户姓名" },
                    model: {
                      value: _vm.model.realname,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "realname", $$v)
                      },
                      expression: "model.realname"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "a-form-item",
            {
              attrs: {
                labelCol: _vm.labelCol,
                wrapperCol: _vm.wrapperCol,
                label: "区域"
              }
            },
            [
              _c(
                "a-dropdown",
                {
                  staticStyle: { float: "left" },
                  attrs: { trigger: ["click"], placement: "topCenter" }
                },
                [
                  _c(
                    "a-menu",
                    { attrs: { slot: "overlay" }, slot: "overlay" },
                    [
                      _c(
                        "a-menu-item",
                        { key: "5", on: { click: _vm.expandAll } },
                        [_vm._v("展开所有")]
                      ),
                      _c(
                        "a-menu-item",
                        { key: "6", on: { click: _vm.closeAll } },
                        [_vm._v("合并所有")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-button",
                    [
                      _vm._v("\n              树操作 "),
                      _c("a-icon", { attrs: { type: "up" } })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "a-form-item",
            {
              attrs: {
                labelCol: _vm.labelCol,
                wrapperCol: _vm.wrapperCol,
                label: ""
              }
            },
            [
              _c(
                "a-row",
                { attrs: { gutter: 10 } },
                [
                  _c(
                    "a-col",
                    { attrs: { md: 10, sm: 24 } },
                    [
                      _c("a-tree", {
                        class: _vm.treeScreenClass,
                        attrs: {
                          checkable: "",
                          checkStrictly: _vm.checkStrictly,
                          checkedKeys: _vm.checkedKeys,
                          treeData: _vm.departTree,
                          expandedKeys: _vm.iExpandedKeys,
                          autoExpandParent: _vm.autoExpandParent
                        },
                        on: { check: _vm.onCheck, expand: _vm.onExpand }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }